import React, { PropTypes, Component } from 'react'

import './ChangeAliadaSearchBase.scss'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'
import SearchSummary from './components/SearchSummary'
import SortOrderControl from './components/SortOrderControl'
import SearchResult from './components/SearchResult'
import { recurrencePeriodicity, serviceTypes } from '@src/globals'

class ChangeAliadaSearchBase extends Component {
  constructor (props) {
    super(props)

    this.state = {
      resultsPage: 0,
      hasSearched: false,
      sortOrder: 'by_finished_services'
    }

    this.showMoreResults = this.showMoreResults.bind(this)
    this.changeSortOrder = this.changeSortOrder.bind(this)
    this.navBarLabel = ' ' // Override this property
  }

  componentDidMount () {
    const { bookingId } = this.props
    this.fetchBooking(bookingId)
  }

  fetchBooking (id) {
    this.props.fetch(id)
  }

  componentDidUpdate (prevProps, prevState) {
    this.searchIfNeeded(prevProps, prevState)
  }

  searchIfNeeded (prevProps, prevState) {
    const { booking } = this.props
    if (!booking) {
      return
    }

    const prevBooking = prevProps.booking
    const prevSortOrder = prevState.sortOrder

    const isFirstSearch = !this.state.hasSearched
    const bookingChanged = (prevBooking && prevBooking.id) !== booking.id
    const sortOrderChanged = prevSortOrder !== this.state.sortOrder

    const needsToSearch = isFirstSearch || bookingChanged || sortOrderChanged
    if (needsToSearch) {
      this.search()
    }
  }

  search () {
    const { booking, search, params: { userId } } = this.props
    const { sortOrder } = this.state

    const querystring = this.buildSearchQuerystring({
      ...booking,
      sort: sortOrder,
      userId,
    })
    search(querystring)

    this.setState({
      hasSearched: true
    })
  }

  buildSearchQuerystring (booking) {
    // Override this function
  }

  renderFlashMessage (booking) {
    // Override this function
  }

  renderSearchResults (data) {
    // Override this function
  }

  renderResult (props) {
    return <SearchResult key={props.aliada.id} {...props} />
  }

  showMoreResults () {
    const { resultsPage } = this.state
    this.setState({
      resultsPage: resultsPage + 1
    })
  }

  changeSortOrder (sortOrder) {
    this.setState({ sortOrder })
  }

  isLoading () {
    const { fetching, booking } = this.props
    return fetching || !booking
  }

  isSearching () {
    return this.props.searching
  }

  resultsDisplayLimit () {
    const RESULTS_PER_PAGE = 6
    return RESULTS_PER_PAGE * (this.state.resultsPage + 1)
  }

  render () {
    const {
      searchResults,
      booking,
      params: {
        userId
      }
    } = this.props

    const { sortOrder } = this.state
    const searching = this.isSearching()
    const loading = this.isLoading()
    const resultsDisplayed = this.resultsDisplayLimit()
    const showMoreButton = !searching && resultsDisplayed < searchResults.length
    const typeId = (booking && 'periodicity' in booking) ? recurrencePeriodicity[booking.periodicity].serviceTypeId : serviceTypes.ONE_TIME.id

    return (
      <div className='ChangeAliadaSearch navbar-screen'>
        <ProfileMobileNavBar back>
          {this.navBarLabel}
        </ProfileMobileNavBar>
        {!loading &&
          <div className='ChangeAliadaSearch-content navbar-screen-content'>
            <div className='ChangeAliadaSearch-contentContainer'>
              {this.renderFlashMessage(booking)}
              <div className='ChangeAliadaSearch-filters'>
                <SearchSummary
                  searchResults={searchResults}
                  searching={searching}
                  typeId={typeId}
                  />
                <SortOrderControl
                  value={sortOrder}
                  onChange={this.changeSortOrder}
                  />
              </div>
              {this.renderSearchResults({searching, searchResults, resultsDisplayed, booking, userId})}
              {showMoreButton &&
                <button
                  className='ChangeAliadaSearch-showMoreBtn btn btn-default btn-lg'
                  onClick={this.showMoreResults}
                  >
                  Ver más resultados
                </button>
              }
            </div>
          </div>
        }
      </div>
    )
  }
}

ChangeAliadaSearchBase.displayName = 'ChangeAliadaSearchBase'
ChangeAliadaSearchBase.propTypes = {
  bookingId: PropTypes.number.isRequired,
  booking: PropTypes.object,
  fetching: PropTypes.bool.isRequired,
  searching: PropTypes.bool.isRequired,
  searchResults: PropTypes.array.isRequired,
  fetch: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  params: PropTypes.shape({
    userId: PropTypes.string.isRequired
  }).isRequired
}
ChangeAliadaSearchBase.defaultProps = {}

export default ChangeAliadaSearchBase



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ChangeAliadaSearchBase/ChangeAliadaSearchBase.js